//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
//import { withStyles } from '@material-ui/core/styles';
import { withStyles } from "@material-ui/core";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
//import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import SecurityIcon from '@material-ui/icons/Security';
//import Icon from '@material-ui/core/Icon';
//import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
//import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import TextsmsIcon from '@material-ui/icons/Textsms';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import NavigationIcon from '@material-ui/icons/Navigation';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Grid from "@material-ui/core/Grid";
import GridList from '@material-ui/core/GridList';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import io from 'socket.io-client';
import Divider from "@material-ui/core/Divider";



const styles = theme => ({
  margin: {
    margin: theme.spacing.unit * 2,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit * 8,
  },
  card: {
    maxWidth:'100%',
    backgroundColor: '#fadcbe',
    borderWidth: 2,
    borderColor: 'black',
    marginBottom: '10px'
  },
  dividerColor1: {
    //marginTop: theme.spacing.unit * 3,
    color: "#40a339",
    backgroundColor: "#40a339",
  },
  
});


//'url(' + require('../../images/IMG_1.JPG')
class ExpandableTowJobInformation extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      age: '',
      name: 'Farshid',
      testnumber: '1232322',
      labelWidth: 0,
      open: false,
    };
    //const unsubscribe = store.subscribe( () => {/*console.log(store.getState())*/});
    this.deleteImageClick = this.deleteImageClick.bind(this);
    this.editImageClick = this.editImageClick.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.PaperComponent = this.PaperComponent.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.showPicturesClick = this.showPicturesClick.bind(this);
    
    
    
  }
  
  
  deleteImageClick(argData) {
    
    //alert('delete was 1 called');
    // this.props.onDelete(argData.id);
    this.setState({ open: true });
    
    
  }
  
  
  
  editImageClick(argData) {
    //alert('edit was  1 called');
    /*const { data} = this.props;
		data.forEach((item)=>{item.editMode = false});
		if(argData.editMode){
				if(argData.editMode == true) {

						argData.editMode = false;
				}else{
						argData.editMode = true;
				}
		}else{
				argData.editMode = true;
		}
		*/
    
    this.props.onEdit(argData);
  }
  
  
  
  
  showPicturesClick(argData) {
    
    this.props.onShowPictures(argData);
  }
  
  
  
  vehicleOwnerTextClick(argData) {
    
    this.props.onVehicleOwnerText(argData);
  }
  
  towAgentTextClick(argData) {
    
    this.props.onTowAgentText(argData);
  }
  
  
  handleClickOpen() {
    this.setState({ open: true });
  };
  
  handleClose() {
    this.setState({ open: false });
  };
  
  handleDelete() {
    this.props.onDelete(this.props.info.id);
    this.setState({ open: false });
  };
  
  PaperComponent(props) {
    return (
      <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
        <Paper {...props} />
      </Draggable>
    );
  }
  
  
  render() {
    const { classes } = this.props;
    // const classes2 = useStyles();
    var ps = new Date(this.props.info.createdDate);
    var hour = ps.getHours() % 12;
    var newformat = ps.getHours() >= 12 ? 'PM' : 'AM';
    ps = (ps.getMonth() + 1) + "/" + ps.getDate() + "/" + ps.getFullYear() + " " + hour + ":" + ps.getMinutes() + " " + newformat;
    let tempImageSource = "/static/images/towtruck.png";
    let towTruckTextImageSource = "/static/images/tow-truck-vehicle.png"
    let tempCarImage = "/static/images/car.png";
    //let tempCarAlarmImage = "/static/images/accident1.png";
    let textingVOImage = "/static/images/phone-message_notify.png";
    let noTextingVOImage = "/static/images/phone-message.png";
    let tempTowImageSource =   "/static/images/question1.png";
    let barBackgroundColor='#f8fc72';
    //ps = ps ;//  +" Status : " +statusText;
    
    if( this.props.info.status ==='Police') {
      tempImageSource =  "/static/images/waiting3.png";
      barBackgroundColor='#0d52db';
    }else if( this.props.info.status ==='Waiting') {
      tempImageSource = "/static/images/waiting3.png";
      barBackgroundColor='#e6e3cc';
    }else if(this.props.info.status ==='Dispatched'){
      tempImageSource = "/static/images/dispatch2.png";
      barBackgroundColor='#84bf82';
    } else if(this.props.info.status ==='Enroute'){
      tempImageSource = "/static/images/enroute1.png";
      barBackgroundColor='#f59e73';
    }else if(this.props.info.status ==='Onscene'){
      tempImageSource = "/static/images/onscene.png";
      barBackgroundColor='#f5473b';
    } else if(this.props.info.status ==='Towing'){
      tempImageSource =  "/static/images/towbrokencar3.png";
      barBackgroundColor='#cc9ef0';
    }else if(this.props.info.status ==='Complete'){
      tempImageSource = "/static/images/complete.png";
      barBackgroundColor='#b5d7f5';
    } else  {
      tempImageSource = "/static/images/question1.png";
      barBackgroundColor='yellow';
    }
    return (
      
      < ExpansionPanel  style={{background: this.props.backgroundColor, marginTop:10}}>
        {/*} < ExpansionPanelSummary expandIcon={< ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header" >
          
          <Grid item xs={2} sm={2} >
            <img height={30} width={30} src={tempImageSource} style={{background:barBackgroundColor}}/>
            <NotificationsActiveIcon  style={{fill: "red" , height:"20", width:"30", marginBottom:"5"}} color="red"   onClick={() => this.vehicleOwnerTextClick(this.props.info)} />
          
          </Grid>
          
          <Grid item xs={7} sm={7}>
            <div>
              < Typography style={{ display: 'inline-block', color: '#054659' }}
                           variant="body2" >
                {this.props.info.privatepropertynumber} <br/>
                {this.props.info.vehiclevin + " - " + this.props.info.vehicleplatenumber + " - " + this.props.info.vehiclestate } <br/>
                {"<-->" + this.props.info.status}
              < /Typography>
            </div>
          </Grid>
          <Grid item xs={3} sm={3}>
            <Tooltip title="Tow Status" aria-label="Tow Status">
              < Typography style={{ display: 'inline-block' }} variant="body2" >
                {ps}
              < /Typography>
            </Tooltip>
          </Grid>
        
        
        
        < /ExpansionPanelSummary>*/}
             
              
              
              < ExpansionPanelSummary expandIcon = { < ExpandMoreIcon / > } aria-controls = "panel2a-content" id = "panel2a-header" >
                
                <Grid item xs={1} sm={1} style={{ maxWidth:50,   marginRight:5,  backgroundColor:barBackgroundColor}}>
                  <img   style={{ marginTop:20, marginLeft:3,color:'white', width:40}} height={40} width={40} src={tempImageSource} />
                  < Typography  style={{  color:'#054659', writingMode:'vertical-lr', rotate:'180deg', fontStretch:'ultra-expanded', paddingRight:10, paddingBottom:15, alignSelf:'stretch'  }} variant = "body2" >
                    {this.props.info.status}
                  </Typography>
                </Grid>
                
                
                <Grid item xs={8} sm={8}>
                  <div>
                    < Typography  style={{display: 'inline-block' , color:'#054659'}} variant = "body2" >
                      < Typography  style={{display: 'inline-block' , color:'#054659', fontWeight:'bold'}} variant = "body2" >
                      {this.props.info.privatepropertynumber}   <br/>
                      </Typography>
                      <br/>
                      < Typography  style={{display: 'inline-block' , color:'black', fontWeight:'bold'}} variant = "body2" >
                      {this.props.info.vehicleyear} - {this.props.info.vehiclemake} - {this.props.info.vehiclemodel} - {this.props.info.vehicleplatenumber} - {this.props.info.vehiclestate} <br/>
                      </Typography>
                      <br/>
                      < Typography  style={{display: 'inline-block' ,   fontWeight:'bold'}} variant = "body2" >Vin: </Typography>  {this.props.info.vehiclevin} <br/>
                      {/*Call Back Number: {this.props.dispatch.callbacknumber } <br/>*/}
                      {/*Po Number: {this.props.dispatch.ponumber  } <br/>*/}
                      {/*Bill To: {this.props.dispatch.billto } <br/>*/}
                      < Typography  style={{display: 'inline-block' ,   fontWeight:'bold'}} variant = "body2" >Vehicle Type: </Typography>  {this.props.info.vehicletype } <br/>
                    < /Typography> <br/>
                    < Typography  style={{display: 'inline-block' , color:'#054659'}} variant = "body2" >
                      < Typography  style={{display: 'inline-block' ,   fontWeight:'bold'}} variant = "body2" >Location: </Typography> {this.props.info.locationaddress1 + " - " + this.props.info.locationaddress2+" "}
                      {this.props.info.locationcity + ", " + this.props.info.locationstate + " " + this.props.info.locationzipcode} <br/>
                      < Typography  style={{display: 'inline-block' ,   fontWeight:'bold'}} variant = "body2" >Destination: </Typography>  {this.props.info.storagelotname}  {this.props.info.storagelotaddress1}
                      {this.props.info.storagelotcity + ", " + this.props.info.storagelotstate + " " + this.props.info.storagelotzipcode}
                    < /Typography>
                  </div>
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Tooltip title="Tow Status" aria-label="Tow Status">
                    < Typography  style={{display: 'inline-block'}} variant = "body2" >
                      {ps}
                    < /Typography>
                  </Tooltip>
                </Grid>
                
                
              
              < /ExpansionPanelSummary>
              
        < ExpansionPanelDetails>
          <Grid container spacing={24}>
            
            
            <Grid item xs={6} sm={6}>
              < Typography style={{ display: 'inline-block', textDecoration: 'underline', color: '#9d32a8' }}
                           variant="subtitle2"
              >
                
                Vehicle:
              < /Typography>
              <br />
              < Typography style={{ display: 'inline-block', fontWeight: 'fontWeightBold', marginLeft: 15 }}
                           variant="body2"
              >
                {this.props.info.vehiclevin} <br />
                {this.props.info.vehicleplatenumber + " - " + this.props.info.vehiclestate} <br />
                {this.props.info.vehiclemake + " - " + this.props.info.vehiclemodel + " - " + this.props.info.vehicleyear}
              
              < /Typography>
            </Grid>
            
            
            <Grid item xs={6} sm={6}>
              < Typography style={{ display: 'inline-block', textDecoration: 'underline', color: '#9d32a8' }}
                           variant="subtitle2"
              >
                Location:
              < /Typography>
              <br/>
              < Typography style={{ display: 'inline-block', marginLeft: 15 }}
                           variant="body2"
              >
                {this.props.info.locationaddress1 + " - " + this.props.info.locationaddress2} <br />
                {this.props.info.locationcity + ", " + this.props.info.locationstate + " " + this.props.info.locationzipcode} <br />
                {this.props.info.locationauthorizedpeople}
              < /Typography>
            </Grid>
            
            <Grid item xs={6} sm={6}>
              < Typography style={{ display: 'inline-block', textDecoration: 'underline', color: '#9d32a8' }}
                           variant="subtitle2" >
                Police:
              < /Typography>
              <br />
              < Typography style={{ display: 'inline-block', marginLeft: 15 }}
                           variant="body2" >
                {this.props.info.policedepartmentname}<br />  {this.props.info.policechiefname}<br />
                {this.props.info.policeaddress1} {this.props.info.policeaddress2} <br />
                {this.props.info.policecity + ", " + this.props.info.policestate + " " + this.props.info.policezipcode}<br />
                {"Fax: " + this.props.info.policefax} <br />
                {"Phone: " + this.props.info.policephone} <br />
                {"Email: " + this.props.info.policeemail}
              
              
              < /Typography>
            </Grid>
            
            
            <Grid item xs={6} sm={6}>
              < Typography style={{ display: 'inline-block', textDecoration: 'underline', color: '#9d32a8' }}
                           variant="subtitle2" >
                Storage Lot:
              < /Typography>
              <br />
              < Typography style={{ display: 'inline-block', marginLeft: 15 }}
                           variant="body2" >
                {this.props.info.storagelotname} <br /> {this.props.info.storagelotaddress1}  <br />
                {this.props.info.storagelotcity + ", " + this.props.info.storagelotstate + " " + this.props.info.storagelotzipcode}
              
              < /Typography>
            </Grid>
            
            
            <Grid item xs={6} sm={6}>
              < Typography style={{ display: 'inline-block', textDecoration: 'underline', color: '#9d32a8' }}
                           variant="subtitle2" >
                Reason:
              < /Typography>
              <br />
              < Typography style={{ display: 'inline-block', marginLeft: 15 }}
                           variant="body2" >
                {this.props.info.reasoncause}
              < /Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
              < Typography style={{ display: 'inline-block', textDecoration: 'underline', color: '#9d32a8' }}
                           variant="subtitle2" >
                Note:
              < /Typography>
              <br />
              < Typography style={{ display: 'inline-block', marginLeft: 15 }}
                           variant="body2" >
                {this.props.info.reasonnote}
              < /Typography>
            </Grid>
            
            <Grid item xs={6} sm={6}>
              < Typography style={{ display: 'inline-block', textDecoration: 'underline', color: '#9d32a8' }}
                           variant="subtitle2" >
                Invoice:
              < /Typography>
              < Typography style={{ display: 'inline-block', marginLeft: 15 }}
                           variant="body2" >
                {this.props.info.invoice}
              < /Typography>
            </Grid>
            
            
            <Grid item xs={6} sm={6}>
              {/* just a place holder */}
            </Grid>
            
            <Grid item xs={12} sm={12}>
              <Divider className={classes.dividerColor1}></Divider>
            </Grid>
            
            <Grid container spacing={24}>
              <Grid item xs={2} sm={2}>
                <Tooltip title="Edit" aria-label="Edit">
                  {/*<IconButton  color="primary" aria-label="edit" className={classes.lowMargin}> */}
                  <EditIcon fontSize="large" onClick={() => this.editImageClick(this.props.info)} />
                  {/* </IconButton> */}
                </Tooltip>
              </Grid>
              <Grid item xs={2} sm={2}>
                
                <Tooltip title="Text Tow Agent Only" aria-label="Text">
                  <img height={40} width={40}   src={towTruckTextImageSource} onClick={() => this.towAgentTextClick(this.props.info)} />
                </Tooltip>
              </Grid>
              
              <Grid item xs={2} sm={2}>
                 <Tooltip title="Text Vehicle Owner" aria-label="Text">
                  <img height={35} width={35} src={noTextingVOImage} onClick={() => this.vehicleOwnerTextClick(this.props.info)} />
                </Tooltip>
                {/*}
                <Tooltip title="New message" aria-label="Text">
                  <img height={40} width={40}     src={textingVOImage} onClick={() => this.vehicleOwnerTextClick(this.props.info)} />
                </Tooltip>*/}
              </Grid>
              {/*}
                                                                                                <Grid item xs={2} sm={2}>
                                                                                                    <Tooltip title="Text Vehicle Owner" aria-label="Text">
                                                                                                        <DirectionsCarIcon  style={{fill: "red"}} color="red" fontSize="large" onClick={() => this.vehicleOwnerTextClick(this.props.info)} />
                                                                                                    </Tooltip>
                                                                                                    <Tooltip title="New message" aria-label="Text">
                                                                                                      <NotificationsActiveIcon   style={{fill: "red" , height:"28", width:"28", marginBottom:"3", marginTop:"2" , }}  fontSize="large" onClick={() => this.vehicleOwnerTextClick(this.props.info)} />
                                                                                                    </Tooltip>
                                                                                                </Grid>  */}
              
              <Grid item xs={2} sm={2}>
                <Tooltip title="Show Pictures" aria-label="Text">
                  <PhotoCameraIcon fontSize="large" onClick={() => this.showPicturesClick(this.props.info)} />
                </Tooltip>
              </Grid>
              
              
              <Grid item xs={2} sm={2}>
                {/*  I ws showing teh email here } <Tooltip title="Email Status" aria-label="Email Status">
                    < Typography  style={{display: 'inline-block'}}
                        variant = "body2" >
                    Emails: fredi@yahoo.com fredi1@gmail.com someoneelse@alo.com
                < /Typography>
                </Tooltip>  */}
              </Grid>
              
              
              <Grid item xs={2} sm={2}>
                {/*}<Tooltip title="Fax Status" aria-label="Fax Status">
                    < Typography  style={{display: 'inline-block'}}
                    variant = "button" >
                    Fax: 1-800-234-2322
                    < /Typography>
                    </Tooltip> */}
              </Grid>
              
              {/*
                <Grid item xs={2} sm={2}>

                <Tooltip title="Tow Status" aria-label="Tow Status">

                    < Typography  style={{display: 'inline-block'}}
                variant = "button" >
                    Status: Complete
                < /Typography>

                </Tooltip>

                    </Grid>
                    */}
            </Grid>
          </Grid>
        
        < /ExpansionPanelDetails>
      < /ExpansionPanel>
    
    )
    
  }//end of render
}//End of class

ExpandableTowJobInformation.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ExpandableTowJobInformation);
